export default function order(
  state = {
    order: null,
    modalOrder: false,
  },
  action
) {
  switch (action.type) {
    case '@order/CREATE': {
      if (state.order) return state;

      const { token, adresses } = action.data;
      const storageOrder = localStorage.getItem(token);
      const order = storageOrder ? JSON.parse(storageOrder) : null;

      if (order && order.v2) {
        return {
          order,
          modalOrder: false,
        };
      }

      const address = adresses.find(f => f.default === 'S');
      const nOrder = {
        token,
        items: [],
        address,
        subtotal: 0,
        delivery: address ? address.delivery : 0,
        total: 0,
        modality: 0,
        payment: { cod: 0, value: 0 },
        v2: true,
      };

      localStorage.setItem(token, JSON.stringify(nOrder));

      return {
        order: nOrder,
        modalOrder: false,
      };
    }

    case '@order/CONFIRMED': {
      const { token, adresses } = action.data;

      const address = adresses.find(f => f.default === 'S');
      const nOrder = {
        token,
        items: [],
        address,
        subtotal: 0,
        delivery: address ? address.delivery : 0,
        total: 0,
        modality: 0,
        payment: { cod: 0, value: 0 },
      };

      localStorage.setItem(token, JSON.stringify(nOrder));

      return {
        order: nOrder,
        modalOrder: false,
      };
    }

    case '@order/ADD_ITEM': {
      if (action.data) {
        const itemOld = state.order.items.find(
          item => item.key === action.data.key
        );

        if (itemOld) {
          const items = state.order.items.map(item => {
            if (item.key === action.data.key) return action.data;

            return item;
          });

          const subtotal = items.reduce((sum, item) => {
            return sum + item.subtotal;
          }, 0);

          const nOrder = {
            ...state.order,
            items,
            subtotal,
            total: subtotal + state.order.delivery,
            payment: { cod: 0, value: 0 },
          };

          localStorage.setItem(state.order.token, JSON.stringify(nOrder));

          return { ...state, order: nOrder };
        }

        const items = [...state.order.items, action.data];

        const subtotal = items.reduce((sum, item) => {
          return sum + item.subtotal;
        }, 0);

        const nOrder = {
          ...state.order,
          items,
          subtotal,
          total: subtotal + state.order.delivery,
          payment: { cod: 0, value: 0 },
        };

        localStorage.setItem(state.order.token, JSON.stringify(nOrder));

        return { ...state, order: nOrder };
      }

      return state;
    }

    case '@order/REMOVE_ITEM': {
      const items = state.order.items.filter(item => item.key !== action.key);

      const subtotal = items.reduce((sum, item) => {
        return sum + item.subtotal;
      }, 0);

      const nOrder = {
        ...state.order,
        items,
        subtotal,
        total: subtotal + state.order.delivery,
        payment: { cod: 0, value: 0 },
      };

      localStorage.setItem(state.order.token, JSON.stringify(nOrder));

      return {
        ...state,
        order: nOrder,
        modalOrder: items.length >= 1,
      };
    }

    case '@order/SET_ADDRESS': {
      if (
        state.order &&
        state.order.address.address_id === action.address.address_id
      )
        return state;

      if (action.address.validated) {
        return {
          ...state,
          order: {
            ...state.order,
            address: action.address,
            delivery: action.address.delivery,
            total: state.order.subtotal + action.address.delivery,
            payment: { cod: 0, value: 0 },
          },
        };
      }
      return state;
    }

    case '@order/SHOW': {
      return {
        ...state,
        modalOrder: true,
      };
    }

    case '@order/CLOSE': {
      return {
        ...state,
        modalOrder: false,
      };
    }

    case '@order/PAYMENT': {
      return {
        ...state,
        order: {
          ...state.order,
          payment: action.payment,
        },
      };
    }

    case '@order/CHANGE_MODALITY': {
      if (action.data.modality === state.order.modality) {
        return state;
      }

      if (action.data.modality === 0) {
        const address = action.data.adresses.find(f => f.default === 'S');
        if (address) {
          return {
            ...state,
            order: {
              ...state.order,
              address,
              delivery: address.delivery,
              total: state.order.subtotal + address.delivery,
              modality: 0,
              payment: { cod: 0, value: 0 },
            },
          };
        }

        return state;
      }

      if (action.data.modality === 1) {
        const address = action.data.adresses.find(
          f => f.neighborhood === 'RETIRAR'
        );

        if (address) {
          return {
            ...state,
            order: {
              ...state.order,
              address,
              delivery: address.delivery,
              total: state.order.subtotal + address.delivery,
              modality: 1,
              payment: { cod: 0, value: 0 },
            },
          };
        }

        return state;
      }

      return {
        ...state,
        order: {
          ...state.order,
          address: null,
          delivery: 0,
          total: state.order.subtotal,
          modality: 2,
          payment: { cod: 0, value: 0 },
        },
      };
    }

    default:
      return state;
  }
}
